import { Box, Typography, IconButton, Select, Button } from "@mui/material";
import styled from "styled-components";

export const ModalContainer = styled(Box)(({ theme }) => ({
  width: "480px",
  background: "#fff",
  borderRadius: "16px",
  padding: "28px",
  boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
  position: "relative",
  outline: "none",
}));

export const Title = styled(Typography)(({ theme }) => ({
  fontSize: "22px",
  fontWeight: 600,
  textAlign: "center",
}));

export const CloseButton = styled(IconButton)(({ theme }) => ({
  position: "absolute",
  right: 12,
  top: 12,
}));

export const Label = styled(Typography)(({ theme }) => ({
  fontSize: "14px",
  fontWeight: 600,
  marginBottom: "6px",
  color: "#555",
}));

export const Dropdown = styled(Select)(({ theme }) => ({
  width: "100%",
  height: "48px",
  borderRadius: "10px",
}));

export const UploadBox = styled(Box)(({ theme }) => ({
  marginTop: "20px",
  border: "2px dashed #b6c2ba",
  borderRadius: "12px",
  padding: "30px 20px",
  textAlign: "center",
  cursor: "pointer",
  transition: "0.3s",
  "&:hover": {
    borderColor: "#7b9c89",
    background: "#f8fdf8",
  },
}));

export const UploadText = styled(Typography)(({ theme }) => ({
  marginTop: "8px",
  fontSize: "14px",
  color: "#777",
}));

export const FileName = styled(Typography)(({ theme }) => ({
  marginTop: "6px",
  fontSize: "14px",
  color: "#999",
}));

export const PrimaryButton = styled(Button)(({ theme }) => ({
  width: "100%",
  backgroundColor: "#6f9e88",
  color: "#fff",
  padding: "10px 0",
  marginTop: "28px",
  borderRadius: "10px",
  fontSize: "16px",
  textTransform: "none",
  "&:hover": {
    backgroundColor: "#5d8874",
  },
}));

export const CancelButton = styled(Button)(({ theme }) => ({
  width: "100%",
  padding: "10px 0",
  marginTop: "12px",
  borderRadius: "10px",
  border: "1px solid #6f9e88",
  color: "#6f9e88",
  fontSize: "16px",
  textTransform: "none",
  background: "transparent",
  "&:hover": {
    backgroundColor: "#eef6f3",
  },
}));